const getAmountWithAppliedFeeIfItExists = (amount, fee) => {
  let updatedAmount
  if (fee && fee.cost) {
    updatedAmount = parseFloat(amount) + parseFloat(fee.cost)
  } else {
    updatedAmount = parseFloat(amount)
  }
  return updatedAmount
}

const getFormattedItemFee = (amount, itemFee) => {
  let itemFeeType
  let itemFeeValue
  let itemFeeCost
  if (itemFee && itemFee.value) {
    itemFeeType = itemFee.type
    if (itemFeeType === 'FLAT') {
      itemFeeCost = itemFee.value
      itemFeeValue = itemFee.value
    } else {
      // round to 100th decimal
      itemFeeCost = Math.round(parseFloat(amount) * itemFee.value * 100) / 100
      itemFeeValue = itemFee.value
    }
  }
  return { type: itemFeeType, value: itemFeeValue, cost: itemFeeCost }
}

// mixin for creating a properly formatted item fee object for a CartItem
const itemFeeMixin = {
  methods: {
    getAmountWithAppliedFeeIfItExists,
    getFormattedItemFee,
    formatFee (item) {
      let feeMessage
      if (item.fee.type === 'PERCENTAGE') {
        feeMessage = `${this.$t(
          'reward-fee-percentage-fee-message-beginning'
        )}${item.fee.value * 100}% ${this.$t(
          'reward-fee-percentage-fee-message-end'
        )}`
      } else {
        feeMessage = this.$t('reward-fee-flat-fee-message')
      }

      return `${this.$money(item.fee.cost, item.currencyCode)} ${feeMessage}`
    }
  }
}

export {
  itemFeeMixin as ItemFeeMixin,
  // exporting these as separate methods since they are used in non-Vue components (i.e. store modules)
  getAmountWithAppliedFeeIfItExists,
  getFormattedItemFee
}
